import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';
import {
  AiChatButton,
  AquistaButton,
  CompanyInfoElements,
  CompanyInformationContainer,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuoteInformationContainer,
  QuoteInformationItem,
  SavedButton,
} from './QuotationCard.styles';

export {
  AquistaButton,
  CompanyInfoElements,
  CompanyInformationContainer,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuoteInformationContainer,
  QuoteInformationItem,
  SavedButton,
};

// Same in-flow tonal chip as the other cards.
export const AiChatButtonEuropeassistance = AiChatButton;

export const EuropeassistanceCardStyles = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 24px;
  height: 100%;
  padding: 20px 24px;
  background: ${v2Colors.inputBackground};
  border: 1px solid ${v2Colors.disabledBorder};
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
  font-family: ${v2FontFamily};
  transition: border-color 150ms ease, box-shadow 150ms ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(16, 24, 40, 0.09);
  }

  &.selected {
    border-color: ${v2Colors.primary};
    box-shadow: 0 0 0 3px ${v2Colors.primarySoftHover};
  }

  /* The card renders a second, empty links row */
  ${CompanyInformationContainer}:empty {
    display: none;
  }

  ${CompanyInformationContainer} {
    margin-top: 14px;
    margin-bottom: 0;
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    flex-direction: column;
    gap: 16px;
    padding: 14px;
  }
`;

export const LeftCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const RightCol = styled.div`
  display: flex;
  flex: 0 0 34%;
  flex-direction: column;
  gap: 12px;
  min-width: 260px;
  max-width: 360px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`;

export const AquistaButtonsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  margin-top: auto;
`;

// "Garanzie Aggiunte"
export const SelectedGuaranteesContainer = styled.div`
  width: 100%;
  padding: 14px 16px;
  border: 1px solid ${v2Colors.disabledSurface};
  border-radius: 12px;
  background: ${v2Colors.surface};

  h2 {
    margin: 0 0 8px;
    color: ${v2Colors.textMuted};
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    text-align: left;
  }

  h2 b {
    color: ${v2Colors.text};
    font-weight: 700;
  }
`;

export const GuaranteesList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  width: 100%;
`;

export const GuaranteesListItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;

  h6 {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 0;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 6px;
      height: 6px;
      margin-top: 6px;
      border-radius: 50%;
      background: ${v2Colors.primary};
    }

    /* the markup puts an empty <span /> before the title; as a flex item it would add a gap */
    span:empty {
      display: none;
    }
  }

  p {
    margin: 0;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
`;
